import GraduatesList from './GraduatesList'
import GraduatesSingle from './GraduatesSingle'
import GraduatesSingleInitialCapabilities from './GraduatesSingleInitialCapabilities'
import GraduatesSingleAssessment from './GraduatesSingleAssessment.vue'

export default {
  GraduatesList,
  GraduatesSingle,
  GraduatesSingleInitialCapabilities,
  GraduatesSingleAssessment
}
